/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import RadioButtonsForm from './RadioButtonsForm.js';
import TextareaForm from './TextareaForm.js'
import SubmitButton from './SubmitButton.js'

export default function ArticleFeedbackForm({updateRatingRequest, namespace}) {
  const articleFeedbackForm = document.createElement('div')
  articleFeedbackForm.id = `${namespace}article_feedback_form`
  articleFeedbackForm.classList.add('feedback_form')

  const radioButtonsForm = RadioButtonsForm({namespace})
  const textareaForm = TextareaForm({namespace})
  const submitButton = SubmitButton({updateRatingRequest, namespace})

  articleFeedbackForm.append(radioButtonsForm, textareaForm, submitButton)
  return articleFeedbackForm
}
